export const managerUsers = {
  usersList: {
    title: "Utilisateurs inscrits",
    subtitle: "Liste des utilisateurs inscrits sur la plateforme.",
    columns: {
      id: "ID",
      name: "Nom",
      phone: "Téléphone",
      email: "E-mail",
      accommodations: "Hébergements",
      sends: "Envois",
      checkin: "Check-in",
      registeredAt: "Date d'inscription",
    },
    states: {
      demo: "Version démo",
      demoEnded: "Démo terminée",
      subscribed: "Abonné",
      subscriptionExpired: "Abonnement expiré",
      queryError: "Erreur de requête",
    },
    deleteAdvisor: {
      confirmMessage: "Êtes-vous sûr de vouloir supprimer ce conseiller ?",
      confirmHeader: "Confirmer",
    },
  },
  accommodationUser: {
    info: "Détails de l'hébergement",
  },
  dataUserOld: {
    accommodationsList: "Liste des hébergements",
    createAccommodation: "Créer un hébergement",
    emptyMessage: "Aucun hébergement enregistré",
    emptySubMessage: "Les hébergements enregistrés par l'utilisateur apparaîtront ici.",
  },
  checkins: {
    title: "Check-ins effectués",
  },
  checkinsPending: {
    title: "Check-ins en attente ou en cours",
  },
};
